import { GetPreviousDataReturn } from '@/dashboards/shared/optimisation/previousData';
import type { OptimizedPlan } from '@/dashboards/shared/optimisation/optimisationSession';
import moment from 'moment';

export const structureMonthlyMediaInvestmentData = ({
    optimizedData,
    rows,
    startDate,
}: { optimizedData: OptimizedPlan | undefined } &
    Pick<GetPreviousDataReturn, 'rows'> & {
        startDate?: string;
    }) => {
    let highestValue = 0;

    const prevDataMonthly = Object.entries(rows).reduce(
        (acc, [key, value]) => {
            const total = Object.values(value).reduce(
                (acc, value) => acc + value,
                0,
            );

            highestValue = Math.max(highestValue, total);

            acc[key] = total;
            return acc;
        },
        {} as Record<string, number>,
    );

    const optimizationStartDate = startDate
        ? moment(startDate, 'DD-MM-YYYY')
        : moment();

    const monthlyMediaData = (optimizedData?.monthly || [])
        .slice(0, 12)
        .map((value, index) => {
            const currentMonth = optimizationStartDate
                .clone()
                .add(index, 'months');
            const month = currentMonth.month() + 1;
            const year = currentMonth.year();
            const monthKey = `${month}`;

            highestValue = Math.max(highestValue, value);
            return {
                month,
                year,
                monthKey: currentMonth.format('YYYY-MM'),
                prevBudget: prevDataMonthly[monthKey] || 0,
                simulatedBudget: value,
            };
        });

    return { highestValue, monthlyMediaData };
};
